/* hs-eslint ignored failing-rules */

/* eslint-disable no-prototype-builtins */
'use es6';

import createAction from 'flux-actions/createAction';
import { SHOULD_SHOW_FREE_LP_ONBOARDING_TOUR, SEEN_STATE_ATTRIBUTES, USER_ATTRIBUTES_TO_FETCH } from '../constants/tour';
import { REQUESTED_USER_ATTRIBUTES, RECEIVED_USER_ATTRIBUTES, REQUESTED_USER_ATTRIBUTES_FAILED, REQUESTED_SET_ATTRIBUTE_FAILURE, REQUESTED_SET_ATTRIBUTE_SUCCESS, REQUEST_SET_ATTRIBUTE } from '../actions/ActionTypes';

const parseUserAttributes = attributes => {
  const parsedAttributes = {};
  USER_ATTRIBUTES_TO_FETCH.forEach(key => {
    if (attributes.hasOwnProperty(key)) {
      let value = attributes[key];

      if (key === SEEN_STATE_ATTRIBUTES) {
        value = JSON.parse(value); // We assume all child keys are date values

        Object.keys(value).forEach(nestedKey => {
          value[nestedKey] = new Date(value[nestedKey]);
        });
        parsedAttributes[key] = value;
      } else if (key === SHOULD_SHOW_FREE_LP_ONBOARDING_TOUR) {
        parsedAttributes[key] = value === 'true';
      }
    }
  });
  return parsedAttributes;
};

export const requestedUserAttributes = createAction(REQUESTED_USER_ATTRIBUTES);
export const receiveAttributes = createAction(RECEIVED_USER_ATTRIBUTES, attributes => ({
  attributes,
  parsedAttributes: parseUserAttributes(attributes)
}));
export const requestedAttributesFailed = createAction(REQUESTED_USER_ATTRIBUTES_FAILED, error => ({
  error
}));
export const requestSetAttribute = createAction(REQUEST_SET_ATTRIBUTE);
export const requestedSetAttributeFailure = createAction(REQUESTED_SET_ATTRIBUTE_FAILURE, error => ({
  error
}));
export const requestedSetAttributeSuccess = createAction(REQUESTED_SET_ATTRIBUTE_SUCCESS);